@if (travelersSameName) {
  <p>
    <ngb-alert
      i18n="@@travelersWithTheSamenameAlert"
      class="alert alert-danger"
      [type]="alert"
      (close)="close()"
    >
      Travellers with the same name not permitted under the same booking.
    </ngb-alert>
  </p>
}

@if (loadingSavedGuests) {
  <div>
    <app-loading-spinner size="sm" />
    <h3 class="loading_message" i18n="@@guestTravellerFormLoadingGuests">
      Loading Saved Guests...
    </h3>
  </div>
}

@if (savedGuests.length) {
  <ng-container class="saved-guests-container">
    <div class="half-container half-container--start saved-guests-wrapper">
      <div class="half-block">
        <label class="header-label" i18n="@@guestTravellerSavedGuests">Saved Guests:</label>
        <mat-select
          (selectionChange)="chooseSavedGuest($event.value)"
          disableOptionCentering
          panelClass="guests-select"
          class="guests-select-box"
          placeholder="Please select..."
          i18n-placeholder
        >
          @for (guest of savedGuests; track guest; let first = $first) {
            <div>
              <div class="guest-wrapper">
                <mat-option [value]="guest.id">
                  {{ guest.title }} {{ guest.forename }} {{ guest.surname }} ({{ guest.email }})
                </mat-option>
                <div>
                  <fa-icon
                    [icon]="faTrash"
                    class="remove-guest-icon"
                    aria-label="remove"
                    tabindex="0"
                    (click)="deleteSavedGuest(guest); $event.stopPropagation()"
                  >
                  </fa-icon>
                </div>
              </div>
            </div>
          }
        </mat-select>
      </div>
      <div class="half-block"></div>
    </div>
  </ng-container>
}

@if (allowGuestBookingsAcrossOffices && offices?.length > 1) {
  <ng-container class="saved-offices-container">
    <div class="half-container half-container--start saved-offices-wrapper">
      <div class="half-block">
        <label class="header-label" i18n="@@guestTravellerSavedOffices">Office:</label>
        <mat-select
          [(value)]="selectedOffice"
          (selectionChange)="chooseOffice($event.value)"
          disableOptionCentering
          panelClass="guests-select"
          class="guests-select-box"
          placeholder="Please select..."
          i18n-placeholder
        >
          <!-- None option -->
          <mat-option [value]="'_none'" i18n="@@guestTravellerNoOffice">None</mat-option>
          <!-- Office options -->
          @for (office of offices; track office) {
            <mat-option [value]="office.id">
              {{ office.officeLabel || office.name }}
            </mat-option>
          }
        </mat-select>
      </div>
      <div class="half-block"></div>
    </div>
  </ng-container>
}

@if (!allowGuestBookingsAcrossOffices && officeName) {
  <ng-container class="saved-offices-container">
    <div class="half-container half-container--start saved-offices-wrapper">
      <div class="half-block">
        <label class="header-label" i18n="@@guestTravellerSavedOffices">Office:</label>
        {{ officeName }}
      </div>
      <div class="half-block"></div>
    </div>
  </ng-container>
}

<!-- Error Message -->
@if (!loading && error) {
  <div>
    <h3 class="loading_message error">{{ error }}</h3>
  </div>
}

@if (!loading) {
  <span i18n="@@required_hint" class="required_hint"
    >Required mandatory fields are marked with an asterisk (*) and must be filled in to complete the
    form.</span
  >
}

@if (!loading) {
  <div ngForm #form="ngForm" id="guestTravellerForm">
    <h3
      id="personal-info-heading"
      class="visuallyhidden"
      i18n="@@guestTravellerFormPersonalInfoLegend"
    >
      Personal Information
    </h3>
    <div role="group" aria-labelledby="personal-info-heading">
      <div class="half-container">
        <div class="two-thirds-container two-thirds-container--ipad-break">
          <div class="two-third">
            <div class="two-thirds-container two-thirds-container--ipad-break">
              <div class="one-third">
                <label for="guest_title" class="header-label" i18n="@@guestTravellerFormTitle"
                  >Title</label
                >
                <select
                  id="guest_title"
                  [(ngModel)]="guest_title"
                  name="guest-title"
                  aria-label="Title"
                  tabindex="0"
                  appSelect
                  [noIcon]="true"
                >
                  @for (title of displayTitles; track title) {
                    <option [ngValue]="title">
                      {{ title.title }}
                    </option>
                  }
                </select>
              </div>
              <div class="two-third">
                <div class="half-container">
                  <div class="half-block">
                    <label
                      for="guest_first_name_input"
                      class="header-label"
                      i18n="@@guestTravellerFormFirstName"
                      >First Name *</label
                    >
                    <input
                      type="text"
                      required="true"
                      id="guest_first_name_input"
                      autocomplete="off"
                      pattern="^[A-Za-z]{1,}([\']|[A-Za-z]){1}([-A-Za-z]){0,}(?:\s[A-Za-z]{1,})*"
                      [(ngModel)]="guest_first_name"
                      name="guest_first_name_input"
                      i18n-placeholder
                      placeholder="Enter guest's first name"
                      aria-label="First name"
                      appInput
                      [noIcon]="true"
                      #firstName="ngModel"
                    />
                  </div>
                  <div class="half-block">
                    <label
                      for="guest_last_name_input"
                      class="header-label"
                      i18n="@@guestTravellerFormLastName"
                      >Last Name *</label
                    >
                    <input
                      type="text"
                      required="true"
                      autocomplete="off"
                      pattern="^[A-Za-z]{1,}([\']|[A-Za-z]){1}([-A-Za-z]){0,}(?:\s[A-Za-z]{1,})*"
                      minlength="2"
                      [(ngModel)]="guest_last_name"
                      name="guest_last_name_input"
                      id="guest_last_name_input"
                      i18n-placeholder
                      placeholder="Enter guest's last name"
                      aria-label="Last name"
                      appInput
                      [noIcon]="true"
                      #lastName="ngModel"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="one-third">
            <label for="guest_email_input" class="header-label">
              <span i18n="@@guestTravellerFormEmail">Email</span>
              @if (emailRequired) {
                <span>&nbsp;*</span>
              }
            </label>
            <input
              type="text"
              [required]="emailRequired"
              autocomplete="off"
              id="guest_email_input"
              pattern='^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
              name="guest_email_input"
              [(ngModel)]="guest_email"
              i18n-placeholder
              placeholder="Enter guest's email"
              aria-label="Email"
              appInput
              [noIcon]="true"
            />
          </div>
        </div>
      </div>
    </div>

    <h3
      id="contact-details-heading"
      class="visuallyhidden"
      i18n="@@guestTravellerFormContactDetailsLegend"
    >
      Contact Details
    </h3>
    <div role="group" aria-labelledby="contact-details-heading">
      <div class="half-container">
        <div class="half-block">
          <div class="two-thirds-container">
            <div class="one-third">
              <label for="mobileNumber" class="header-label">
                <span i18n="@@guestTravellerFormMobileCountryCode">Mobile Country Code</span>
                @if (isFlightSelected) {
                  <span>&nbsp;*</span>
                }
              </label>
              <input
                autocomplete="off"
                pattern="(\+?\d{1,3}|\d{1,4})"
                appInput
                [noIcon]="true"
                name="mobileCountryNo"
                i18n-placeholder
                id="mobileNumber"
                placeholder="Country Code"
                [required]="isFlightSelected"
                [(ngModel)]="guestMobileCountryNo"
                type="text"
                min="0"
              />
            </div>
            <div class="two-third">
              <label for="mobileNumber-2" class="header-label">
                <span i18n="@@guestTravellerFormMobileNumber">Mobile Number</span>
                @if (isFlightSelected) {
                  <span>&nbsp;*</span>
                }
              </label>
              <input
                autocomplete="off"
                pattern="[0-9]{9,10}"
                appInput
                [noIcon]="true"
                name="mobileNumber"
                id="mobileNumber-2"
                i18n-placeholder
                placeholder="Mobile Number"
                [required]="isFlightSelected"
                [(ngModel)]="guestMobileNumber"
                type="text"
              />
            </div>
          </div>
        </div>
        <div class="half-block">
          <h3 id="additional-info-heading" class="visuallyhidden">
            <span i18n="@@boltAdditionalInformation">Additional Information</span>
          </h3>
          <div role="group" aria-labelledby="additional-info-heading">
            <div class="half-container">
              <div class="half-block">
                <label
                  for="guest_country_select"
                  class="header-label"
                  i18n="@@guestTravellerFormNationality"
                  >Nationality</label
                >
                <select
                  [(ngModel)]="guest_nationality"
                  name="guest_country_select"
                  id="guest_country_select"
                  appSelect
                  [noIcon]="true"
                >
                  <option [ngValue]="''" selected i18n="@@guestTravellerFormChooseAnOption">
                    Choose an option
                  </option>
                  @for (country of searchService.getCountries(); track country) {
                    <option [ngValue]="country.cCode">
                      {{ country.cName }}
                    </option>
                  }
                </select>
              </div>
              <div class="half-block">
                <label for="guest_gender" class="header-label" i18n="@@guestTravellerFormGender"
                  >Gender *</label
                >
                <select
                  name="guest_gender"
                  [required]="true"
                  [disabled]="disableGenderDropdown()"
                  [(ngModel)]="guest_title.gender"
                  tabindex="0"
                  id="guest_gender"
                  appSelect
                  [noIcon]="true"
                >
                  @for (gender of genders; track gender) {
                    <option [ngValue]="gender">
                      {{ gender | translate }}
                    </option>
                  }
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h3 id="child-info-heading" class="visuallyhidden" i18n="@@guestTravellerFormChildInfoLegend">
      Child Information
    </h3>
    <div role="group" aria-labelledby="child-info-heading">
      @if (searchService.getCurrentNoOfTravellers() >= 1 && childAllowed) {
        <div class="flex-row-container child-row">
          <mat-checkbox
            color="primary"
            class="light-primary"
            value="Manual"
            [disabled]="!(searchService.getCurrentNoOfTravellers() >= 1)"
            [checked]="isChild"
            (change)="isChild = !isChild"
            i18n="@@guestTravellerFormIsChild"
          >
            Traveller is a child
          </mat-checkbox>
          <section (mouseleave)="tt.close()" class="container">
            <i
              class="ico-info child-warning-icon"
              i18n-ngbTooltip
              ngbTooltip="An adult traveller needs to be added before you can add a child"
              aria-label="An adult traveller needs to be added before you can add a child"
              triggers="manual"
              #tt="ngbTooltip"
              (mouseenter)="tt.open()"
              (focus)="tt.open()"
              (blur)="tt.close()"
              tabindex="0"
              ><span class="visuallyhidden"
                >An adult traveller needs to be added before you can add a child</span
              ></i
            >
          </section>
          @if (isChild) {
            <div class="flex-column-container">
              <label for="isChild">
                <span i18n="@@guestTravellerFormChildDob">Childs Date of Birth</span>
                @if (isFlightSelected) {
                  <span>&nbsp;*</span>
                }
              </label>
              <i class="ico-calendar combo-box-icon cursor_pointer" aria-hidden="true"></i>
              <input
                autocomplete="off"
                class="combo-box"
                i18n-placeholder
                placeholder="Select childs date of birth"
                [required]="isFlightSelected"
                name="dp"
                [minDate]="minChildDate"
                [maxDate]="maxChildDate"
                [startDate]="childDOB"
                [(appValidateDate)]="childDOB"
                [(ngModel)]="childDOB"
                [displayMonths]="deviceDetector.displayMonths"
                [navigation]="'select'"
                ngbDatepicker
                #dp
                container="body"
                #d="ngbDatepicker"
                (click)="d.toggle()"
                placement="left"
                tabindex="0"
                id="isChild"
                firstDayOfWeek="7"
              />
            </div>
          }
        </div>
      }
    </div>
    @if (isChild) {
      <div class="child-warn">
        <p i81n="@@childEU">
          <br />
          <strong>Please Note for EU Rail Only:</strong>
          For children between 0-5 years old you will be able to enter their specific age on the
          search form. Please select the lowest possible date of birth to add them as a guest.
        </p>
      </div>
    }
    <div class="flex-row-container flex-row-container--right">
      <button
        type="button"
        appButton="large"
        [disabled]="!form.form.valid"
        [class.large-button--disabled]="!form.form.valid"
        form="guestTravellerForm"
        [attr.aria-disabled]="!form.form.valid"
        (click)="submitGuest()"
        id="guest-button-save"
        i18n="@@guestTravellerFormSaveGuestDetails"
      >
        Save guest details
      </button>
    </div>
  </div>
}

<!-- Loading Spinner - show when fetching countries on init -->
@if (loading) {
  <div>
    <app-loading-spinner size="sm" />
    <h3 class="loading_message" i18n="@@guestTravellerFormLoading">Loading...</h3>
  </div>
}

<div class="clearfix"></div>
